import React from 'react';
import { BsTwitter, BsToggleOff ,BsGithub } from 'react-icons/bs';
import { FaLinkedin } from 'react-icons/fa';
import {BiToggleLeft} from 'react-icons/bi';
import {GiSpellBook} from 'react-icons/gi';
import useLocalStorage from 'use-local-storage';
import '../App.scss';
import '../index.css';


const SocialMedia = () => {
  const [theme, setTheme] = useLocalStorage('theme' ? 'dark' : 'light');

  const switchTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme)
  };

  return  (
  <div className="app__social" data-theme = {theme}>
    <div >
      <a href ='https://twitter.com/PiyushV78107699'><BsTwitter /></a>
    </div>
    <div >
      <a href = 'https://www.linkedin.com/in/piyush-verma-7a2510203/'><FaLinkedin /></a>
    </div>
    <div>
      <a  href = 'https://github.com/piyushvermaco'><BsGithub /></a>
    </div>
    <div>
        <a  href = 'https://docs.google.com/document/d/1odLA6XRjFPKaq4UPHcFdwjYc7tWGWXKw/edit?usp=sharing&ouid=104177852159463667345&rtpof=true&sd=true'><GiSpellBook /></a>
        <p className='s-text'>Resume</p>
    </div>
    <div>
      <button onClick={switchTheme}>< BiToggleLeft/></button>
    </div>
  </div>
  );
};

export default SocialMedia;

